import React, { useEffect, useState } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import TechnologyBrowseModal from './TechnologyBrowseModal';
import { useDispatch, useSelector } from 'react-redux';
import { loadTechnologyDropdown } from '../redux/action';
import { technologyOptions } from '../CommonFile/DropdownValues';

const Technologies = ({ selected, setSelected, search, setSearch, showModal, setShowModal, viewResult }) => {

    const dispatch = useDispatch();
    const { technologyDropdown } = useSelector((state) => state.data);
    const [loadingTechnologies, setLoadingTechnologies] = useState(false);

    const handleRemove = (itemToRemove) => {
        setSelected(selected.filter(item => item !== itemToRemove));

        if (selected.filter(item => item !== itemToRemove).length === 0) {
            setSearch("");
        }
    };

    useEffect(() => {
        if (showModal) {
            dispatch(loadTechnologyDropdown('all', setLoadingTechnologies));
        }
    }, [showModal, dispatch]);

    const applyModalSelections = () => {
        if (selected.length === 0) {
            setSearch('');
        }
        setSelected(selected);
        setShowModal(false);
    };

    return (
        <div className="search-contact-filter-container-second-third-div  mt-4">
            <div className="search-contact-filter-container-second-third-inner-div">
                <h6>🖥️ Technologies</h6>
            </div>
            <Form className="search-contact-form-container">
                <Row className="mb-3">
                    <Col md={viewResult ? 12 : 6}>
                        <Form.Group controlId="contactLevel">
                            <Form.Label className="pb-2 pt-2">Technologies</Form.Label>
                            <div className="type-head-selected-container mb-2">
                                {selected.map((item, index) => (
                                    <div key={index} className="type-head-selected-options">
                                        <span
                                            className="cross-mark"
                                            onClick={() => handleRemove(item)}
                                        >
                                            &times;
                                        </span>
                                        <span style={{ flex: 1 }}>{item}</span>
                                    </div>
                                ))}
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <Typeahead
                                    flip={true}
                                    className="w-100"
                                    id="technology-typeahead"
                                    options={
                                        loadingTechnologies
                                            ? ['Loading data...']
                                            : technologyOptions?.map(opt => opt.label).filter(opt => !selected.includes(opt))
                                    }
                                    placeholder="Enter technology"
                                    onInputChange={(val) => {
                                        setSearch(val);
                                        if (val.trim() === '') {
                                            setSearch("");
                                        }
                                    }}
                                    onChange={(val) => {
                                        if (val.length > 0 && !selected.includes(val[0])) {
                                            setSelected([...selected, val[0]]);
                                        }
                                    }}
                                    selected={[]}
                                />
                            </div>
                        </Form.Group>
                    </Col>
                </Row>
            </Form>

            <TechnologyBrowseModal
                show={showModal}
                onClose={() => setShowModal(false)}
                onApply={applyModalSelections}
                options={technologyDropdown}
                selected={selected}
                setSelected={setSelected}
                search={search}
                setSearch={setSearch}
                loadingTechnologies={loadingTechnologies}
            />
        </div>
    );
};

export default Technologies;
